import { useKnowledgeContext } from '@knowledge/knowledges/general/KnowledgeContext';
import { useEventListener } from 'ahooks';
import { RefObject, useEffect } from 'react';

function useNeuronKnowledge(iframeRef: RefObject<HTMLIFrameElement>, neuronId: string) {
  const { knowledgeExampleMap, showKnowledgeListMoal, getKnowledgeExample } = useKnowledgeContext();

  useEventListener('message', (e) => {
    if (
      !e.data ||
      e.data.neuronId !== neuronId ||
      !iframeRef.current ||
      !iframeRef.current.contentWindow
    ) {
      return;
    }

    if (e.data.type === 'showKnowledgeListMoal') {
      showKnowledgeListMoal(e.data.data);
    }

    if (e.data.type === 'getKnowledgeExample') {
      getKnowledgeExample(e.data.data);

      iframeRef.current.contentWindow.postMessage(
        {
          type: 'knowledgeExampleMapUpdate',
          data: knowledgeExampleMap,
          neuronId,
        },
        '*',
      );
    }
  });

  useEffect(() => {
    if (!iframeRef.current || !iframeRef.current.contentWindow) {
      return;
    }

    iframeRef.current.contentWindow.postMessage(
      {
        type: 'knowledgeExampleMapUpdate',
        data: knowledgeExampleMap,
        neuronId,
      },
      '*',
    );
  }, [iframeRef, knowledgeExampleMap, neuronId]);
}

export default useNeuronKnowledge;
